module.exports = __webpack_public_path__ + "img/Italian.36d36989.svg";